const proposalInsightsPage = `
{{#> hartford/NavLayout currentPage=currentPage Pages=Pages basePath=basePath logoUrl=project.values.logoUrl }}
  <div class="proposal-insights-page">
    <div class="container">
      {{#each pageContext.proposal_insights}}
        <div class="proposal-section">
          <h3 class="proposal-title">{{this.title}}</h3>

          <div class="proposal-content">
            <div class="proposal-images">
              <div class="proposal-image">
                <img src="{{this.image1}}" alt="{{this.title}} - Image 1" />
              </div>

              {{#if this.image2}}
                <div class="proposal-image">
                  <img src="{{this.image2}}" alt="{{this.title}} - Image 2" />
                </div>
              {{/if}}
            </div>

            <div class="proposal-texts">
              <div class="proposal-text">
                <p>{{this.text1}}</p>
              </div>

              {{#if this.text2}}
                <div class="proposal-text">
                  <p>{{this.text2}}</p>
                </div>
              {{/if}}
            </div>
          </div>
        </div>

        {{#unless @last}}
          <div class="proposal-divider"></div>
        {{/unless}}
      {{/each}}
    </div>
  </div>
{{/hartford/NavLayout}}
`;

const proposalInsightItem = `
<div class="proposal-section">
  <h3 class="proposal-title">{{this.title}}</h3>

  <div class="proposal-content">
    <div class="proposal-images">
      <div class="proposal-image">
        <img src="{{this.image1}}" alt="{{this.title}} - Image 1" />
      </div>

      {{#if this.image2}}
        <div class="proposal-image">
          <img src="{{this.image2}}" alt="{{this.title}} - Image 2" />
        </div>
      {{/if}}
    </div>

    <div class="proposal-texts">
      <div class="proposal-text">
        <p>{{this.text1}}</p>
      </div>

      {{#if this.text2}}
        <div class="proposal-text">
          <p>{{this.text2}}</p>
        </div>
      {{/if}}
    </div>
  </div>
</div>
`;

const proposalInsightsPageStyles = `
  .proposal-insights-page {
    padding: 60px 0;
    background-color: #ffffff;
  }

  .container {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .proposal-section {
    margin-bottom: 50px;
  }

  .proposal-title {
    color: rgb(0, 82, 163);
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 30px 0;
    position: relative;
    padding-bottom: 15px;
  }

  .proposal-content {
    display: flex;
    gap: 40px;
  }

  .proposal-images {
    flex: 0 0 45%;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .proposal-image {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .proposal-image img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.5s ease;
  }

  .proposal-image:hover img {
    transform: scale(1.03);
  }

  .proposal-texts {
    flex: 0 0 55%;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .proposal-text {
    font-size: 16px;
    line-height: 1.7;
    color: #555;
  }

  .proposal-text p {
    margin: 0;
  }

  .proposal-divider {
    height: 1px;
    background: linear-gradient(to right, rgba(0, 102, 204, 0.05), rgba(0, 102, 204, 0.5), rgba(0, 102, 204, 0.05));
    margin: 50px 0;
    position: relative;
  }

  .proposal-divider:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #0066cc;
    border-radius: 50%;
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 992px) {
    .proposal-content {
      flex-direction: column;
    }

    .proposal-images, .proposal-texts {
      flex: 0 0 100%;
    }
  }

  @media (max-width: 768px) {
    .proposal-section {
      padding: 30px;
    }

    .proposal-title {
      font-size: 24px;
    }
  }

  @media (max-width: 576px) {
    .proposal-insights-page {
      padding: 40px 0;
    }

    .headline {
      font-size: 28px;
      margin-bottom: 40px;
    }

    .proposal-section {
      padding: 25px;
    }

    .proposal-title {
      font-size: 22px;
      margin-bottom: 20px;
    }
  }
`;

export const proposalInsightsBlocks: any[] = [
  {
    name: 'hartford/ProposalInsightsPage',
    partial: proposalInsightsPage,
    css: proposalInsightsPageStyles,
  },
  {
    name: 'hartford/ProposalInsightItem',
    partial: proposalInsightItem,
    css: proposalInsightsPageStyles,
  },
];
